export const slugifyTitle = (title: string): string =>
  title
    .toString()
    .toLowerCase()
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/&/g, "-and-")
    .replace(/[\s\W-]+/g, "-");
